var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldLinkCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12c0 5.52 4.48 10 10 10s10-4.48 10-10S17.52 2 12 2 2 6.48 2 12zm5.95 3.26c-.09 0-.17-.01-.26-.05-.81-.3-1.49-.89-1.92-1.66-1-1.8-.38-4.15 1.37-5.24l2.34-1.45c.86-.53 1.87-.69 2.83-.44.96.25 1.77.88 2.26 1.76 1 1.8.38 4.15-1.37 5.24l-.26.19a.76.76 0 0 1-1.05-.17.76.76 0 0 1 .17-1.05l.31-.22c1.12-.7 1.5-2.15.89-3.26-.29-.52-.76-.89-1.32-1.04-.56-.15-1.15-.06-1.66.26L7.92 9.59c-1.08.67-1.46 2.12-.85 3.24.25.45.65.8 1.13.98.39.14.59.57.45.96-.11.3-.4.49-.7.49zm6.63 1.84a3.59 3.59 0 0 1-2.83.43c-.96-.25-1.77-.88-2.25-1.76-1-1.8-.38-4.15 1.37-5.24l.26-.19a.76.76 0 0 1 1.05.17c.24.34.16.81-.17 1.05l-.31.22c-1.12.7-1.5 2.15-.89 3.26.29.52.76.89 1.32 1.04.56.15 1.15.06 1.66-.26l2.34-1.45c1.08-.67 1.46-2.12.85-3.24-.25-.45-.65-.8-1.13-.98a.736.736 0 0 1-.44-.96.74.74 0 0 1 .96-.44c.81.3 1.49.89 1.92 1.66.99 1.8.38 4.15-1.37 5.24l-2.34 1.45z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldLinkCircle);
export default __webpack_public_path__ + "static/media/vuesax-bold-link-circle.83ee42e715d4e05c611442073804e15b.svg";
export { ForwardRef as ReactComponent };